import React from 'react'
import { withAppContextDecorators } from '@/common/AppContext';
import { Breadcrumb } from 'antd';
import './index.less'
import {useHistory} from "react-router-dom";
const UserNotice = (props) => {
    const history = useHistory()
    const userNotice = {
        userAgreement: {
            text: [
                "用户必读",
                "As You Known",
                "感谢您选择国诚投顾的产品，为了更好的给您提供服务，请您仔细阅读以下内容，以便更好的保障您的权益。<br/>第一、我们只提供专业的证券投资咨询服务，并无期货、现货等业务，对客户不保底、不保证收益，也不分担投资收益和投资损失。我司不会代替您理财或操盘，所有操作建议仅供您参考，投资操作需要您来最终决定。<br/>第二、我们禁止公司员工使用私人手机等非公司电话与您取得联系，更不会让您除对公账户以外的其他途径向您私下收取任何费用，请自行保护好您的账户安全。"
            ]
        },
        quadrelBan: {
            text: [
                "国诚红线十禁",
                "What's Not Allowed ",
                "严禁违规开发:禁止向不合格投资者或未评估风险承受能力的客户提供公司服务;<br/>严禁消极怠客:禁止使用不当言语辱骂、刁难客户，推诿、延迟处理客户问题;<br/>严禁私自推荐:禁止业务私自荐股、私自诊股，私自炒股、私自解盘、提供任何涉及证券的投资建议;<br/>严禁虚假宣传:禁止虚假、伪造、误导宣传等行为欺骗客户;<br/>严禁泄露信息:禁止盗取公司机密资料、倒卖客户信息等;<br/>严禁保证收益:禁止承诺客户保证收益、本金不受损失或分享收益、分担损失;<br/>严禁代客理财:禁止代替客户进行股票账户操作等其他形式的理财;<br/>严禁不当获利:禁止私下以各种形式收受客户财物;<br/>严禁激化风险:禁止直接或者变相拖延客户的退款;<br/>严禁脱离留痕:禁止私下索取客户联系方式，使用私人手机及其他方式联系客户脱离留痕系统。"
            ]
        }
    }

    return <div id="userNotice">
        <div className={'breadcrumb-con warp'}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={()=>{history.push({pathname:'/index'})}}>首页</Breadcrumb.Item>
               <Breadcrumb.Item>用户告知</Breadcrumb.Item>
            </Breadcrumb>
        </div>

        <div className={'centerBox warp'}>
            <div className={'list'}>
                <div className={'list-con'}>
                    <div className={'list-title'}>
                        <h2>{userNotice.userAgreement.text[0]}</h2>
                        <p>{userNotice.userAgreement.text[1]}</p>
                    </div>
                    <div className={'list-describe'} dangerouslySetInnerHTML={{__html:userNotice.userAgreement.text[2]}}></div>
                </div>
                <img src={require(`@/assets/images/compliance/img6.png`)} />
            </div>

            <div className={'list'}>
                <div className={'list-con'}>
                    <div className={'list-title'}>
                        <h2>{userNotice.quadrelBan.text[0]}</h2>
                        <p>{userNotice.quadrelBan.text[1]}</p>
                    </div>
                    <div className={'list-describe'} dangerouslySetInnerHTML={{__html:userNotice.quadrelBan.text[2]}}></div>
                </div>
                <img src={require(`@/assets/images/compliance/img7.png`)} />
            </div>

        </div>
    </div>
}
export default withAppContextDecorators(UserNotice)
